import styled, { css } from "styled-components";

export const StyledPhoneLink = styled.a`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    color: ${({ theme }) => theme.primaryTypographyColor};
`;

export const StyledInfoBlock = styled.div<{ $borderBottom?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${({ $borderBottom }) =>
        $borderBottom &&
        css`
            border-bottom: 1px solid #313131;
            margin-bottom: 16px;
            padding-bottom: 16px;
        `}
`;
